import { render, staticRenderFns } from "./Modals.vue?vue&type=template&id=0abc0c83&scoped=true&"
import script from "./Modals.vue?vue&type=script&lang=js&"
export * from "./Modals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc0c83",
  null
  
)

export default component.exports